module.exports = __webpack_public_path__ + "static/img/yjjh.3a28e33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/yjjh.png
// module id = i4xB
// module chunks = 0